module.exports = __webpack_public_path__ + "static/img/hnga.cb898a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hnga.svg
// module id = 103
// module chunks = 40